
// import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
// import rootReducer from './reducers/reducers';

// const store = configureStore({
//     reducer: rootReducer,
//     middleware: (getDefaultMiddleware) =>
//       getDefaultMiddleware({
//         immutableCheck: false,
//         serializableCheck: false,
//       }),
//   });
  

// export default store;

// store.js
// store.js

import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers/reducers';
import errorHandler from './middleware/errorHandler'; // Optional for global error handling

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable serializability check
      immutableCheck: false, // Disable immutability check if you want
    }).concat(errorHandler),
});

export default store;

